export default "__VITE_ASSET__378085d4__"